import { render, staticRenderFns } from "./MonthlyStockTransfer.vue?vue&type=template&id=2442286c"
import script from "./MonthlyStockTransfer.vue?vue&type=script&lang=js"
export * from "./MonthlyStockTransfer.vue?vue&type=script&lang=js"
import style0 from "./MonthlyStockTransfer.vue?vue&type=style&index=0&id=2442286c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports